<div class="app-modal-title">Flip Road Direction</div>
<div class="app-modal-content">
	<div class="align-wrap">
		<div class="transpose-lock">
			<div class="column-item">
				<div class="transpose-checkbox" title="Flip Left-Right">
					<input type="checkbox" name="transposeCheckAll" [(ngModel)]="transposeCheckAll" (ngModelChange)="toggleTransposeCheckAll()">
				</div>
				<div></div>
				<div class="column-value">
					Left
				</div>
				<div class="column-value">
					Right
				</div>
			</div>

			<div class="column-item" *ngFor="let col of cols; let idx = index">
				<div class="transpose-checkbox">
					<input type="checkbox" name="transpose-{{idx}}" title="Flip Left-Right" [(ngModel)]="col.isTransposed">
				</div>
				<div>{{col.neutralName}}</div>
				<div class="column-value">
					<input disabled value="{{record[col.leftProp]}}">
				</div>
				<div class="column-value">
					<input disabled value="{{record[col.rightProp]}}">
				</div>
			</div>

		</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" (click)="cancel()">Cancel</button>
		<button class="button-general" (click)="apply()">Apply</button>
	</div>
</div>